import { c as _c } from "react/compiler-runtime";
import { EMBEDDED_FORM_FIELDS_API } from 'modules/funnels/funnel/api/step-configuration-api';
import { FunnelStepPageId } from 'modules/funnels/funnel/types/funnel-step-interface';
import { EmbeddedFormFieldsInterface } from 'modules/funnels/funnel/types/remote-form-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import useSWR from 'swr';
export function useEmbeddedFormFields(shouldFetch, pageId) {
  const $ = _c(7);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== pageId || $[2] !== shouldFetch || $[3] !== user) {
    t1 = () => {
      if (user && pageId && shouldFetch) {
        return `${EMBEDDED_FORM_FIELDS_API}/${pageId}/html`;
      }
      return null;
    };
    $[1] = pageId;
    $[2] = shouldFetch;
    $[3] = user;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    data: embeddedFormFields
  } = useSWR(t1, fetcher);
  let t2;
  if ($[5] !== embeddedFormFields) {
    t2 = {
      embeddedFormFields
    };
    $[5] = embeddedFormFields;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}